export const formatCompactNumber = (value: number, precision = 1) => {
  if (!Number.isFinite(value)) {
    return '0'
  }

  return Number.isInteger(value) ? String(value) : value.toFixed(precision).replace(/\.0+$|(?<=\.[0-9]*[1-9])0+$/u, '')
}

export const formatLoggedWork = (totalHours: number, payType?: string | null, workHoursPerDay = 8.5) => {
  const safeHoursPerDay = Number.isFinite(workHoursPerDay) && workHoursPerDay > 0 ? workHoursPerDay : 8.5
  const days = totalHours / safeHoursPerDay
  const dayText = `${formatCompactNumber(days, 2)} ${days === 1 ? 'day' : 'days'}`

  if (payType === 'per_day') {
    return `${dayText} logged`
  }

  const hourText = `${formatCompactNumber(totalHours)} ${totalHours === 1 ? 'hr' : 'hrs'}`
  if (payType === 'per_hour') {
    return `${hourText} logged (${dayText})`
  }

  return `${hourText} logged`
}